import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=20051edd&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=20051edd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20051edd",
  null
  
)

export default component.exports